import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import vodAdapter from 'shared/utils/adapters/vod';


const ACTIONS = createAsyncActions('SERVER.CHANNEL.REMOVE');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;


export default function (id) {
  return function (dispatch) {
    const params = { id };
    dispatch(START(params));

    return vodAdapter.lists.remove(id)
      .then(
        function (response) {
          dispatch(SUCCESS(params, response));
          return response;
        },

        function (response) {
          dispatch(FAIL(params, response, { analytics: { type: 'error', name: 'dashboard.channel.remove' } }));
        }
      );
  };
}



// WEBPACK FOOTER //
// ./src/dashboard/redux/server/actions/channel/remove.js